export const videos = [
  {
    id: "v001",
    title: "深海迷航",
    category: "movie",
    categoryName: "电影",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dark%20deep%20ocean%20submarine%20exploration%20scene%20with%20glowing%20blue%20light%20and%20dramatic%20atmosphere%2C%20film%20poster%20style%2C%20rich%20teal%20and%20orange%20contrast%2C%20high%20detail&width=640&height=360&seq=sese-v001&orientation=landscape",
    duration: "02:14:30",
    publishDate: "2026-09-28",
    uploadTime: "2026-09-28 20:15",
    playCount: 4280000,
    score: 9.2,
    featured: true,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "科幻" },
    description: "一支深海科考队在马里亚纳海沟发现了一座沉睡的远古遗迹，未知生物与人性考验随之而来。影片以震撼的视听语言呈现深海奇观，探讨科技与自然的边界。",
  },
  {
    id: "v002",
    title: "长夜将明",
    category: "movie",
    categoryName: "电影",
    cover: "https://readdy.ai/api/search-image?query=neon%20lit%20rainy%20hong%20kong%20street%20at%20night%20with%20lone%20detective%20silhouette%2C%20crime%20thriller%20film%20aesthetic%2C%20moody%20red%20and%20dark%20tones%2C%20cinematic%20composition&width=640&height=360&seq=sese-v002&orientation=landscape",
    duration: "01:48:12",
    publishDate: "2026-09-20",
    uploadTime: "2026-09-20 10:30",
    playCount: 3120000,
    score: 8.9,
    featured: true,
    tags: { region: "中国香港", year: "2025", language: "粤语", genre: "犯罪" },
    description: "一桩悬案牵扯出三十年间的家族秘密，老刑警在长夜里追寻真相，也追寻自己失去的东西。港式犯罪片的全新表达，节奏紧凑、悬念迭起。",
  },
  {
    id: "v003",
    title: "山间来信",
    category: "movie",
    categoryName: "电影",
    cover: "https://readdy.ai/api/search-image?query=peaceful%20japanese%20mountain%20village%20in%20autumn%20with%20small%20wooden%20house%20and%20falling%20leaves%2C%20warm%20soft%20sunlight%2C%20gentle%20drama%20film%20poster%20style%2C%20harmonious%20natural%20tones&width=640&height=360&seq=sese-v003&orientation=landscape",
    duration: "02:01:45",
    publishDate: "2026-09-12",
    uploadTime: "2026-09-12 15:40",
    playCount: 1860000,
    score: 8.6,
    featured: false,
    tags: { region: "日本", year: "2024", language: "日语", genre: "剧情" },
    description: "都市青年回到故乡整理祖母遗物，意外发现一叠从未寄出的信件。在缓慢的季节更替中，他重新理解了亲情与离别的含义。",
  },
  {
    id: "v004",
    title: "星际归途",
    category: "movie",
    categoryName: "电影",
    cover: "https://readdy.ai/api/search-image?query=epic%20space%20station%20orbiting%20a%20colorful%20planet%20with%20spaceship%20and%20distant%20stars%2C%20grand%20science%20fiction%20scene%2C%20orange%20nebula%20and%20deep%20blue%20space%2C%20cinematic&width=640&height=360&seq=sese-v004&orientation=landscape",
    duration: "02:22:08",
    publishDate: "2026-10-02",
    uploadTime: "2026-10-02 09:20",
    playCount: 5210000,
    score: 9.4,
    featured: true,
    tags: { region: "美国", year: "2026", language: "英语", genre: "科幻" },
    description: "一次失败的星际移民任务后，唯一的幸存者必须独自穿越虫洞回到地球。孤独、希望与人类文明的意义在浩瀚星空中被重新书写。",
  },
  {
    id: "v005",
    title: "都市晨光",
    category: "tv",
    categoryName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20golden%20sunrise%20with%20young%20professionals%20walking%2C%20urban%20drama%20poster%20style%2C%20warm%20orange%20and%20clean%20white%20tones%2C%20optimistic%20mood&width=640&height=360&seq=sese-v005&orientation=landscape",
    duration: "45:12",
    publishDate: "2026-10-08",
    uploadTime: "2026-10-08 21:00",
    playCount: 2680000,
    score: 8.8,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "都市" },
    description: "三个怀抱梦想的年轻人在大城市相遇，从合租室友到并肩创业。剧集以细腻笔触描摹当代都市青年的奋斗与温情，真实且治愈。",
  },
  {
    id: "v006",
    title: "锦衣夜行",
    category: "tv",
    categoryName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20palace%20courtyard%20at%20night%20with%20lanterns%20and%20elegant%20costumed%20figure%2C%20historical%20loyalty%20drama%20aesthetic%2C%20deep%20red%20and%20gold%20tones%2C%20cinematic&width=640&height=360&seq=sese-v006&orientation=landscape",
    duration: "42:36",
    publishDate: "2026-09-30",
    uploadTime: "2026-09-30 20:30",
    playCount: 3490000,
    score: 9.0,
    featured: true,
    tags: { region: "中国大陆", year: "2025", language: "国语", genre: "古装" },
    description: "一名身负秘密的锦衣卫潜入朝堂漩涡，在家国大义与个人情感之间艰难抉择。权谋布局环环相扣，服化道考究精致。",
  },
  {
    id: "v007",
    title: "迷雾之岛",
    category: "tv",
    categoryName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20foggy%20island%20with%20lighthouse%20and%20stormy%20sea%2C%20british%20suspense%20series%20aesthetic%2C%20cold%20blue%20and%20grey%20tones%2C%20tense%20atmosphere&width=640&height=360&seq=sese-v007&orientation=landscape",
    duration: "52:04",
    publishDate: "2026-09-25",
    uploadTime: "2026-09-25 18:00",
    playCount: 1540000,
    score: 8.7,
    featured: false,
    tags: { region: "英国", year: "2024", language: "英语", genre: "悬疑" },
    description: "六名陌生人在一座被浓雾封锁的小岛上醒来，彼此的秘密逐渐浮出水面。英式悬疑的冷静叙事与层层反转，让人欲罢不能。",
  },
  {
    id: "v008",
    title: "海边的餐厅",
    category: "tv",
    categoryName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=cozy%20seaside%20restaurant%20with%20warm%20lights%20and%20ocean%20view%20at%20dusk%2C%20korean%20healing%20drama%20poster%20style%2C%20soft%20peach%20and%20cream%20tones%2C%20warm%20inviting%20mood&width=640&height=360&seq=sese-v008&orientation=landscape",
    duration: "48:20",
    publishDate: "2026-10-05",
    uploadTime: "2026-10-05 22:10",
    playCount: 2210000,
    score: 9.1,
    featured: false,
    tags: { region: "韩国", year: "2026", language: "韩语", genre: "治愈" },
    description: "一位失意的料理师在海边小镇开了一家小餐厅，用一道道家常菜治愈来往客人的心伤，也慢慢与自己和解。",
  },
  {
    id: "v009",
    title: "快乐实验室",
    category: "variety",
    categoryName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=bright%20colorful%20game%20show%20stage%20with%20confetti%20and%20playful%20props%2C%20energetic%20variety%20tv%20aesthetic%2C%20vibrant%20orange%20and%20red%20tones%2C%20fun%20atmosphere&width=640&height=360&seq=sese-v009&orientation=landscape",
    duration: "68:30",
    publishDate: "2026-10-07",
    uploadTime: "2026-10-07 20:00",
    playCount: 1980000,
    score: 8.5,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "真人秀" },
    description: "明星嘉宾化身研究员，在各种脑洞大开的实验中挑战极限。笑料不断的互动设计，是周末放松的最佳选择。",
  },
  {
    id: "v010",
    title: "一起露营吧",
    category: "variety",
    categoryName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=group%20of%20friends%20camping%20under%20starry%20night%20sky%20with%20tent%20and%20campfire%2C%20outdoor%20reality%20show%20aesthetic%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20cozy%20mood&width=640&height=360&seq=sese-v010&orientation=landscape",
    duration: "72:15",
    publishDate: "2026-09-29",
    uploadTime: "2026-09-29 21:30",
    playCount: 1420000,
    score: 8.3,
    featured: false,
    tags: { region: "中国大陆", year: "2025", language: "国语", genre: "户外" },
    description: "几位好友远离城市，在山野间搭帐篷、生篝火、聊人生。慢节奏的户外纪实，让观众在星空下找到久违的松弛感。",
  },
  {
    id: "v011",
    title: "厨房奇遇记",
    category: "variety",
    categoryName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=chef%20cooking%20in%20a%20rustic%20warm%20kitchen%20with%20fresh%20ingredients%20and%20steam%2C%20food%20cooking%20show%20aesthetic%2C%20rich%20orange%20and%20wood%20tones%2C%20appetizing%20mood&width=640&height=360&seq=sese-v011&orientation=landscape",
    duration: "58:40",
    publishDate: "2026-10-01",
    uploadTime: "2026-10-01 19:20",
    playCount: 1120000,
    score: 8.2,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "美食" },
    description: "素人厨艺达人与专业名厨同台切磋，用寻常食材创造惊喜美味。每一道菜背后都有一个温暖的生活故事。",
  },
  {
    id: "v012",
    title: "云上乐园",
    category: "animation",
    categoryName: "动画",
    cover: "https://readdy.ai/api/search-image?query=whimsical%20floating%20islands%20in%20the%20sky%20with%20rainbow%20and%20cute%20creatures%2C%20fantasy%20animation%20poster%20style%2C%20bright%20vivid%20colors%2C%20playful%20imaginative%20scene&width=640&height=360&seq=sese-v012&orientation=landscape",
    duration: "01:32:20",
    publishDate: "2026-10-03",
    uploadTime: "2026-10-03 10:00",
    playCount: 2540000,
    score: 9.0,
    featured: true,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "奇幻" },
    description: "一座漂浮在云端的神秘乐园，住着一群守护梦想的小精灵。当黑暗降临，勇敢的女孩踏上了拯救乐园的奇幻冒险。",
  },
  {
    id: "v013",
    title: "小恐龙的旅行",
    category: "animation",
    categoryName: "动画",
    cover: "https://readdy.ai/api/search-image?query=cute%20friendly%20little%20dinosaur%20walking%20through%20a%20green%20prehistoric%20forest%20with%20butterflies%2C%20family%20animation%20style%2C%20warm%20sunny%20green%20and%20yellow%20tones%2C%20cheerful%20adventure&width=640&height=360&seq=sese-v013&orientation=landscape",
    duration: "01:18:05",
    publishDate: "2026-09-18",
    uploadTime: "2026-09-18 14:00",
    playCount: 1680000,
    score: 8.4,
    featured: false,
    tags: { region: "美国", year: "2025", language: "英语", genre: "冒险" },
    description: "一只与众不同的小恐龙独自踏上寻找家人的旅程，途中结识了形形色色的伙伴。关于勇气与友谊的合家欢动画。",
  },
  {
    id: "v014",
    title: "神域少年",
    category: "anime",
    categoryName: "动漫",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20anime%20hero%20with%20glowing%20energy%20aura%20in%20battle%2C%20japanese%20shonen%20style%2C%20intense%20red%20and%20orange%20effects%2C%20action%20packed%20dramatic%20scene&width=640&height=360&seq=sese-v014&orientation=landscape",
    duration: "24:10",
    publishDate: "2026-10-06",
    uploadTime: "2026-10-06 12:00",
    playCount: 3860000,
    score: 9.3,
    featured: true,
    tags: { region: "日本", year: "2026", language: "日语", genre: "热血" },
    description: "平凡少年意外觉醒了沉睡千年的神域之力，为了守护同伴与家园，他踏上与黑暗势力对抗的热血征程。作画水准一流。",
  },
  {
    id: "v015",
    title: "樱花纷落时",
    category: "anime",
    categoryName: "动漫",
    cover: "https://readdy.ai/api/search-image?query=gentle%20anime%20scene%20of%20two%20students%20under%20cherry%20blossom%20trees%20with%20petals%20falling%2C%20soft%20pastel%20pink%20palette%2C%20romantic%20slice%20of%20life%20atmosphere&width=640&height=360&seq=sese-v015&orientation=landscape",
    duration: "23:40",
    publishDate: "2026-09-22",
    uploadTime: "2026-09-22 13:30",
    playCount: 1920000,
    score: 8.9,
    featured: false,
    tags: { region: "日本", year: "2024", language: "日语", genre: "治愈" },
    description: "在樱花纷飞的校园里，两个性格迥异的少年少女相遇。细腻的情感刻画与唯美画面，谱写了一曲青春的温柔序章。",
  },
  {
    id: "v016",
    title: "蓝色星球笔记",
    category: "documentary",
    categoryName: "纪录片",
    cover: "https://readdy.ai/api/search-image?query=underwater%20coral%20reef%20with%20colorful%20tropical%20fish%20and%20sunlight%20rays%2C%20nature%20documentary%20aesthetic%2C%20vivid%20turquoise%20and%20orange%20tones%2C%20awe%20inspiring&width=640&height=360&seq=sese-v016&orientation=landscape",
    duration: "50:20",
    publishDate: "2026-09-15",
    uploadTime: "2026-09-15 09:00",
    playCount: 1340000,
    score: 9.1,
    featured: false,
    tags: { region: "英国", year: "2025", language: "英语", genre: "自然" },
    description: "历时三年拍摄，横跨全球五大洋，记录海洋生物的奇妙生存智慧。每一帧都是令人屏息的自然奇观。",
  },
  {
    id: "v017",
    title: "丝路千年",
    category: "documentary",
    categoryName: "纪录片",
    cover: "https://readdy.ai/api/search-image?query=ancient%20silk%20road%20caravan%20crossing%20desert%20dunes%20at%20golden%20sunset%2C%20historical%20documentary%20aesthetic%2C%20warm%20amber%20and%20earth%20tones%2C%20grand%20epic%20mood&width=640&height=360&seq=sese-v017&orientation=landscape",
    duration: "55:30",
    publishDate: "2026-09-08",
    uploadTime: "2026-09-08 16:40",
    playCount: 980000,
    score: 9.0,
    featured: false,
    tags: { region: "中国大陆", year: "2024", language: "国语", genre: "历史" },
    description: "沿着古丝绸之路的足迹，探寻东西方文明交流的千年往事。文物、遗迹与学者的讲述，共同还原一条伟大的文明之路。",
  },
  {
    id: "v018",
    title: "巅峰对决",
    category: "sports",
    categoryName: "体育",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20basketball%20player%20dunking%20in%20a%20packed%20arena%20with%20spotlights%2C%20sports%20highlight%20aesthetic%2C%20energetic%20orange%20and%20dark%20tones%2C%20high%20energy&width=640&height=360&seq=sese-v018&orientation=landscape",
    duration: "38:15",
    publishDate: "2026-10-04",
    uploadTime: "2026-10-04 22:30",
    playCount: 1760000,
    score: 8.6,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "篮球" },
    description: "总决赛巅峰对决完整集锦，末节惊天逆转的每一个瞬间都被精准还原。专业解说带你重温那记改变胜负的压哨三分。",
  },
  {
    id: "v019",
    title: "冰雪之约",
    category: "sports",
    categoryName: "体育",
    cover: "https://readdy.ai/api/search-image?query=skier%20carving%20down%20a%20snowy%20mountain%20slope%20with%20snow%20spray%2C%20winter%20sports%20aesthetic%2C%20crisp%20white%20and%20blue%20tones%2C%20thrilling%20motion&width=640&height=360&seq=sese-v019&orientation=landscape",
    duration: "42:00",
    publishDate: "2026-09-26",
    uploadTime: "2026-09-26 11:00",
    playCount: 1080000,
    score: 8.5,
    featured: false,
    tags: { region: "挪威", year: "2025", language: "英语", genre: "滑雪" },
    description: "跟随世界顶尖滑雪运动员挑战极限雪道，记录训练、失利与登顶的全过程。速度与勇气在冰雪间尽情释放。",
  },
  {
    id: "v020",
    title: "城市音乐现场",
    category: "music",
    categoryName: "音乐",
    cover: "https://readdy.ai/api/search-image?query=live%20music%20concert%20stage%20with%20singer%20and%20glowing%20stage%20lights%20and%20crowd%2C%20modern%20pop%20concert%20aesthetic%2C%20vibrant%20red%20and%20orange%20tones%2C%20energetic&width=640&height=360&seq=sese-v020&orientation=landscape",
    duration: "88:20",
    publishDate: "2026-10-09",
    uploadTime: "2026-10-09 21:15",
    playCount: 1490000,
    score: 8.8,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "流行" },
    description: "年度城市音乐节完整现场，多位实力唱将同台献唱。从抒情慢歌到炸场狂欢，一场不可复制的音乐盛宴。",
  },
  {
    id: "v021",
    title: "午夜爵士",
    category: "music",
    categoryName: "音乐",
    cover: "https://readdy.ai/api/search-image?query=intimate%20jazz%20club%20performance%20with%20saxophone%20player%20in%20warm%20spotlight%2C%20moody%20vintage%20aesthetic%2C%20deep%20amber%20and%20dark%20tones%2C%20soulful%20atmosphere&width=640&height=360&seq=sese-v021&orientation=landscape",
    duration: "64:10",
    publishDate: "2026-09-11",
    uploadTime: "2026-09-11 23:00",
    playCount: 720000,
    score: 8.7,
    featured: false,
    tags: { region: "美国", year: "2024", language: "英语", genre: "爵士" },
    description: "走进一间百年爵士酒吧，聆听萨克斯与钢琴的即兴对话。舒缓的旋律与昏黄的灯光，适合深夜独处的你。",
  },
  {
    id: "v022",
    title: "幻境征服者",
    category: "game",
    categoryName: "游戏",
    cover: "https://readdy.ai/api/search-image?query=epic%20video%20game%20battle%20scene%20with%20fantasy%20warrior%20and%20glowing%20magic%2C%20game%20art%20style%2C%20dramatic%20purple%20and%20orange%20effects%2C%20intense%20action&width=640&height=360&seq=sese-v022&orientation=landscape",
    duration: "35:40",
    publishDate: "2026-10-08",
    uploadTime: "2026-10-08 15:20",
    playCount: 2130000,
    score: 8.9,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "动作" },
    description: "热门动作大作的完整通关实况，主播细致讲解每一个隐藏关卡的破解技巧。超高难度 BOSS 战一镜到底，热血拉满。",
  },
  {
    id: "v023",
    title: "策略大师赛",
    category: "game",
    categoryName: "游戏",
    cover: "https://readdy.ai/api/search-image?query=esports%20tournament%20arena%20with%20players%20at%20computers%20and%20big%20screens%2C%20competitive%20gaming%20aesthetic%2C%20cool%20blue%20and%20magenta%20stage%20lights%2C%20tense%20focus&width=640&height=360&seq=sese-v023&orientation=landscape",
    duration: "96:50",
    publishDate: "2026-09-19",
    uploadTime: "2026-09-19 20:00",
    playCount: 1320000,
    score: 8.6,
    featured: false,
    tags: { region: "韩国", year: "2025", language: "韩语", genre: "竞技" },
    description: "年度策略游戏大师赛决赛全程，两支顶尖战队的巅峰博弈。战术布局、心理博弈与临场应变，每一步都决定胜负。",
  },
  {
    id: "v024",
    title: "未来之家",
    category: "tech",
    categoryName: "科技",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20smart%20home%20interior%20with%20holographic%20interfaces%20and%20minimal%20design%2C%20modern%20tech%20aesthetic%2C%20clean%20white%20and%20warm%20orange%20lighting%2C%20sleek%20sophisticated&width=640&height=360&seq=sese-v024&orientation=landscape",
    duration: "28:30",
    publishDate: "2026-10-10",
    uploadTime: "2026-10-10 18:30",
    playCount: 890000,
    score: 8.8,
    featured: false,
    tags: { region: "中国大陆", year: "2026", language: "国语", genre: "数码" },
    description: "探访全球最具前瞻性的智能住宅，体验语音控制、全屋互联的未来生活。测评师带你理性看待每一项黑科技。",
  },
];

export const featuredVideos = ["v001", "v004", "v006", "v012", "v014"];